module.exports = __webpack_public_path__ + "img/aboutCompany__left.5e3d0c8a.png";